import type { TypeError } from "#public"
import type { Result } from "#public"

import { Failure } from "./Failure"
import { Success } from "./Success"

type Guard<T> = (value: unknown) => value is T
type Guarded<G> = G extends Guard<infer T> ? T : never

// Ensure a value matches one of the given type guards. The result type is the
// union of the guards' narrowed types — `Ensure(value, StringQ, NumberQ)`
// infers `Result<string | number>` with no explicit type argument. Succeeds with
// the (narrowed) value, otherwise fails with `TYPE_ERROR`.
export const Ensure = <const Guards extends Guard<unknown>[]>(
  input: unknown,
  ...guards: Guards
): Result<Guarded<Guards[number]>, TypeError> =>
  guards.some(guard => guard(input))
    ? Success(input as Guarded<Guards[number]>)
    : Failure("TYPE_ERROR", { input })
